import { addNewSalesInvoicesRoutes } from "@routes/addNewSalesinvoices/route";
import { customerListRoutes } from "@routes/basicInfo/customerList/route";
import { employeeListRoutes } from "@routes/basicInfo/employeeList/route";
import { financialYearListRoutes } from "@routes/basicInfo/financialYearList/route";
import { itemCategoryRoutes } from "@routes/basicInfo/itemCategoryManagement/route";
import { measurementUnitRoutes } from "@routes/basicInfo/measurementUnitManagement/route";
import { supplierListRoutes } from "@routes/basicInfo/supplierList/route";
import { warehouseListRoutes } from "@routes/basicInfo/warehouseList/route";
import { employeeCostManagementRoutes } from "@routes/costManagement/employeeCost/route";
import { storeCostManagementRoutes } from "@routes/costManagement/storeCost/route";
import { dashboardRoutes } from "@routes/dashboard/route";
import { debtRoutes } from "@routes/financialManagement/debt/route";
import { incomeRoutes } from "@routes/financialManagement/income/route";
import { subscriptionRoutes } from "@routes/financialManagement/subscription/route";
import { notificationsRoutes } from "@routes/notifications/route";
import { plansManagementRoutes } from "@routes/plansManagement/route";
import { purchaseInvoicesRoutes } from "@routes/purchaseManagement/purchaseInvoices/route";
import { purchaseReturnsListRoutes } from "@routes/purchaseManagement/returnsList/route";
import { bestSellingItemsReportRoutes } from "@routes/reportManagement/bestSellingItemsReport/route";
import { employeeActivityReportRoutes } from "@routes/reportManagement/employeeActivityReport/route";
import { financialReportRoutes } from "@routes/reportManagement/financialReport/route";
import { generalSalesReportRoutes } from "@routes/reportManagement/generalSalesReport/route";
import { itemBasedSalesReportRoutes } from "@routes/reportManagement/itemBasedSalesReport/route";
import { purchaseReportRoutes } from "@routes/reportManagement/purchaseReport/route";
import { salesReportRoutes } from "@routes/reportManagement/salesReport/route";
import { supplierBasedSalesReportRoutes } from "@routes/reportManagement/supplierBasedSalesReport/route";
import { topCustomerReportRoutes } from "@routes/reportManagement/topCustomerReport/route";
import { warehouseCirculationReportManagementRoutes } from "@routes/reportManagement/warehouseCirculationReport/route";
import { returnsListRoutes } from "@routes/salesManagement/returnsList/route";
import { salesInvoiceRoutes } from "@routes/salesManagement/salesInvoice/route";
import { settingsRoutes } from "@routes/settings/route";
import { storesManagementRoutes } from "@routes/storesManagement/route";
import { centralWarehouseInventoryRoutes } from "@routes/warehouseManagement/centralWarehouseInventory/route";
import { priceListRoutes } from "@routes/warehouseManagement/priceList/route";
import { quantityInventoryOfWasteWarehouseRoutes } from "@routes/warehouseManagement/quantityInventoryOfWasteWarehouse/route";
import { salesWarehouseInventoryRoutes } from "@routes/warehouseManagement/salesWarehouseInventory/route";
import { warehouseCirculationReportRoutes } from "@routes/warehouseManagement/warehouseCirculationReport/route";

import { supportRoutes } from "./support/route";

import type { IExtendedRouteObject } from "./types";

export const routes: IExtendedRouteObject[] = [
  ...dashboardRoutes,
  ...supportRoutes,
  ...settingsRoutes,
  ...plansManagementRoutes,
  ...storesManagementRoutes,
  ...subscriptionRoutes,
  ...incomeRoutes,
  ...debtRoutes,
  ...notificationsRoutes,
  ...customerListRoutes,
  ...employeeListRoutes,
  ...itemCategoryRoutes,
  ...measurementUnitRoutes,
  ...supplierListRoutes,
  ...warehouseListRoutes,
  ...storeCostManagementRoutes,
  ...employeeCostManagementRoutes,
  ...centralWarehouseInventoryRoutes,
  ...priceListRoutes,
  ...quantityInventoryOfWasteWarehouseRoutes,
  ...salesWarehouseInventoryRoutes,
  ...warehouseCirculationReportRoutes,
  ...addNewSalesInvoicesRoutes,
  ...salesInvoiceRoutes,
  ...returnsListRoutes,
  ...purchaseInvoicesRoutes,
  ...purchaseReturnsListRoutes,
  ...warehouseCirculationReportManagementRoutes,
  ...bestSellingItemsReportRoutes,
  ...employeeActivityReportRoutes,
  ...financialReportRoutes,
  ...purchaseReportRoutes,
  ...salesReportRoutes,
  ...topCustomerReportRoutes,
  ...generalSalesReportRoutes,
  ...itemBasedSalesReportRoutes,
  ...supplierBasedSalesReportRoutes,
  ...financialYearListRoutes,
];
